<template>
  <div>
    <el-dialog
      class="hidden-check-dlialog"
      :visible.sync="showDialog"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding:0;"
    >
      <div class="content">
        <div class="hidden-close" @click="closeDialog">
          关闭
        </div>
        <div class="content-title">
          <!-- <img :src="fileIcon[params.type]" alt="" /> -->
          <span v-if="params.type == 0">所有隐患</span>
          <span v-if="params.type == 1">未处理隐患</span>
          <span v-if="params.type == 4">已验收隐患</span>
        </div>
        <div class="select-box">
          <el-select
            v-model="schoolId"
            @change="schoolChange"
            @clear="clearSchoolId"
            clearable
            filterable
            size="small"
            placeholder="请选择单位"
            :popper-append-to-body="false"
          >
            <!-- <el-option label="全部" value=""></el-option> -->
            <el-option
              v-for="item in schoolList"
              :key="item.collegeId"
              :label="item.collegeName"
              :value="item.collegeId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="table-wrapper">
          <el-table
            :row-style="getRowClass"
            :cell-style="tableCellStyle"
            :header-row-style="getRowClass"
            :header-cell-style="getRowClass"
            :data="tableData"
            height="430px"
            border
            v-loading="tableLoading"
          >
            <el-table-column
              label="单位名称"
              show-overflow-tooltip
              align="center"
              prop="schoolName"
            >
            </el-table-column>
            <el-table-column
              label="隐患编号"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerNumber"
            ></el-table-column>
            <el-table-column
              label="隐患图片"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerImgUrl"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  title="点击放大图片"
                  :src="
                    $store.state.config.fileUrl + scope.row.hiddenDangerImgUrl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl + scope.row.hiddenDangerImgUrl
                  ]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              label="整改图片"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerImgAfterurl"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.hiddenDangerImgAfterurl"
                  style="width: 50px; height: 50px"
                  title="点击放大图片"
                  :src="
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgAfterurl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl +
                      scope.row.hiddenDangerImgAfterurl
                  ]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              label="隐患等级"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerClass"
            >
            </el-table-column>
            <el-table-column
              label="隐患来源"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerFrom"
            >
            </el-table-column>
            <el-table-column
              label="隐患描述"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerDescribe"
            >
            </el-table-column>
            <el-table-column
              label="隐患类别"
              show-overflow-tooltip
              align="center"
              prop="hiddenDangerClassifyName"
            >
            </el-table-column>
            <el-table-column
              label="报告人"
              show-overflow-tooltip
              align="center"
              prop="reportUserName"
            >
            </el-table-column>
            <el-table-column
              label="处理人"
              show-overflow-tooltip
              align="center"
              prop="disposeUserName"
            >
            </el-table-column>
            <el-table-column
              label="最近操作时间"
              show-overflow-tooltip
              align="center"
              prop="LastOperatingTime"
            >
            </el-table-column>
            <el-table-column
              label="状态"
              prop="hiddenDangerStatus"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pagination"
          :page-size="params.pageSize"
          :pager-count="5"
          :current-page="params.pageNum"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "hiddenDangerDialog",
  props: {
    showCount: {
      type: Number,
      default: {
        return: 0
      }
    },
    searchParams: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showDialog: false,
      params: {
        schoolIds: [], // 学校id
        type: 0,
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      tableLoading: false,
      total: 0,
      schoolList: [],
      schoolId: ""
    };
  },

  created() {},
  mounted() {},
  methods: {
    async getSchoolList(id) {
      let req = {
        collegeId: id
      };
      let res = await this.$Http.getCollegeList(req);
      if (res.code == 200) {
        this.schoolList = res.data.map((item) => {
          return {
            collegeId: item.schoolId,
            collegeName: item.schoolName
          };
        });
        if (this.searchParams.collegeId) {
          this.params.schoolIds = [this.searchParams.collegeId];
          this.params.status = this.searchParams.status;
          this.schoolId = this.searchParams.collegeId;
        } else {
          this.params.schoolIds = this.schoolList.map((item, index) => {
            return item.collegeId;
          });
          this.params.status = this.searchParams.status;
          this.schoolId = "";
        }
        this.params.pageNum = 1;
        this.params.pageSize = 20;
        this.total = 0;
        this.getEduSchoolHiddenDangerInfo();
      } else if (res.code == 101) {
        this.schoolList = [];
      } else {
        this.schoolList = [];
      }
    },
    schoolChange(val) {
      this.params.schoolIds = [val];
      this.getEduSchoolHiddenDangerInfo();
    },
    clearSchoolId() {
      this.params.schoolIds = this.schoolList.map((item) => {
        return item.collegeId;
      });
      this.getEduSchoolHiddenDangerInfo();
    },
    async getEduSchoolHiddenDangerInfo() {
      this.tableLoading = true;
      let req = Object.assign({}, this.params);
      let res = await this.$Http.getCollegeDangersList(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 分页点击
    currentChange(val) {
      this.params.pageNum = val;
      this.getEduSchoolHiddenDangerInfo();
    },
    // 修改 table cell边框的背景色
    tableCellStyle() {
      return "border-color: #fff;";
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#c4f0ff;color:#c4f0ff";
    },
    closeDialog() {
      this.showDialog = false;
    }
  },
  watch: {
    showCount: function(newVal) {
      if (newVal) {
        this.getSchoolList(this.searchParams.schoolId);
      }
      this.showDialog = true;
    }
  }
};
</script>
<style scoped lang="scss">
.hidden-check-dlialog {
  /deep/ .el-dialog {
    width: 1100px;
    height: 600px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png")
      center center no-repeat;
    background-size: 100% 100%;
      padding: 20px 46px 10px 34px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .select-box {
    position: relative;
    margin-bottom: 10px;
    /deep/ .el-select {
      .el-input__inner {
        background-color: transparent;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4f0ff;
        line-height: 20px;
      }
      .el-select-dropdown {
        background: rgba(28, 102, 168, 0.8);
        box-shadow: 0px 0px 28px 0px #3f78bc inset;
        position: absolute !important;
        top: 26px !important;
      }
      .el-select-dropdown__item {
        color: #ffffff;
      }
      .el-select-dropdown__item.hover {
        color: #c4f0ff;
        background: rgba(25, 63, 97,0.8);
      }
      .el-select-dropdown__item.selected,
      .el-select-dropdown__item.selected.hover {
        color: #409eff;
        background: rgba(25, 63, 97,0.8);
      }
    }
  }
  .content {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: relative;
    .hidden-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 0px;
      right: 0;
      cursor: pointer;
    }
    .content-title {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        margin-left: 16px;
        font-size: 24px;
        color: #d7deff;
      }
    }
  }
  .table-wrapper {
    /deep/ .el-table {
      padding: 0px;
      background-color: transparent;
      .el-table__expanded-cell {
        background-color: transparent;
      }
      th,
      tr {
        background-color: transparent !important;
        &:hover td {
          background-color: transparent !important;
        }
      }
      .el-table--enable-row-transition {
        .el-table__body {
          td {
            background-color: transparent;
            color: #c4cdff;
          }
        }
      }
      .cell {
        background-color: transparent;
        color: #c4cdff;
      }
    }
  }
  .pagination {
    /deep/ &.el-pagination {
      margin: 10px;
      float: right;
      background-color: transparent;
      .el-pagination__total {
        color: rgba(255, 255, 255, 0.8);
      }
      button {
        width: 28px;
        min-width: 28px;
        border-radius: 6px;
        background: transparent;
        border: 1px solid rgba(44, 166, 252, 1);
        box-shadow: inset 0px 1px 16px 0px rgba(65, 77, 161, 0.5);
        &:hover {
          background: rgba(44, 166, 252, 1);
        }
        &:disabled {
          background: transparent;
          cursor: default;
        }
        .el-icon {
          color: #ffffff;
          &.el-icon-arrow-right {
            position: relative;
            left: -4px;
          }
        }
      }
      .el-pager {
        li {
          color: rgba(255, 255, 255, 0.6);
          background: transparent;
          &:hover,
          &.active {
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
